export const environment = {
  production: true,
  buildId: '3658487040722961',
  configFile: 'config.json',
};
